import { UID } from "@strapi/strapi";
import { RunContextApp } from "framework/RCApp";

export const CommentsApis = {

  postComment : async (rc : RunContextApp, contentType : UID.ContentType, 
                       documentId : string, content : string) => {

    const resp = await rc.cmsApiClient.post(`/comments/${contentType}:${documentId}`, {
      content
    }, true)
    return resp
  },

  updateComment : async (rc : RunContextApp, contentType : UID.ContentType, 
                         documentId : string, commentId : string, content : string) => {

    const resp = await rc.cmsApiClient.post(`/comments/${contentType}:${documentId}/comment/${commentId}`, {
      content
    }, true)
    return resp
  },

  deleteComment : async (rc : RunContextApp, contentType : UID.ContentType, 
                         documentId : string, commentId : number, authorId : number) => {

    const resp = await rc.cmsApiClient.delete(`/comments/${contentType}:${documentId}/comment/${commentId}?authorId=${authorId}`)
    return resp
  },

  getComments : async (rc : RunContextApp, contentType : UID.ContentType, 
                       documentId : string) => {

    const resp = await rc.cmsApiClient.get(`/comments/${contentType}:${documentId}`)
    return resp
  },

  getCommentCount : async (rc : RunContextApp, contentType : UID.ContentType, 
                           documentIds : string[]) => {

    const resp = await rc.cmsApiClient.post(`/global/commentCount`, {
      contentTypeUid : contentType,
      entryDocumentIds : documentIds.toString()
    })
    return resp
  }
}